import angular from 'angular';

angular.module('ll.core').run(momentTranslation);

momentTranslation.$inject = ['moment'];
function momentTranslation(moment) {
  moment.locale(window.navigator.languages);
}
